// extracted by mini-css-extract-plugin
export default {"header":"Header_header__3MkER","logotype":"Header_logotype__gGp68","settings":"Header_settings__U19c9"};